import React, { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"




/* Widget Preloader */
class Preloader extends Component {

    render = () => {

        const { url } = this.props

        const gameImg = url ? url : `${env.mediapoint}/images/back-casino.webp`

        return (
            <div className="preloader">
                <Picture className="full-image" src={gameImg} alt="backgrounf" />
                <div className="preloader-logo">
                    <Picture src={`${env.mediapoint}/images/logo.png`} alt="Preloader" />
                    <div className="preloader-logo-text">
                        <div className="vip">VIP</div>
                        <p>RUSSIAN</p>
                        <span>POKER {env && env.number ? env.number : ""}</span>
                    </div>
                </div>
                <div className="preloader-indicator">
                    <Picture className="line" src={`${env.mediapoint}/images/preloader/preloader.svg`} alt="Preloader" />
                    <Picture className="star" src={`${env.mediapoint}/images/preloader/star.svg`} alt="Preloader" />
                    {/* <div className="preloader-indicator-bar" /> */}
                </div>
                <p className="support">При поддержке</p>
                <Picture className="makao" src={`${env.mediapoint}/electronic/images/cubago.png`} alt="Preloader" />
            </div>
        )
    }

}

export default Preloader